
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GroupeCle extends Vue {

  private headers1 = [
    {value: "name", text: "Nom"},
    {value: "actions", text: ""},
  ];
  private items1 = [
    {
      name: " Canon T04-134 BLEU",
    },
    {
      name: " Canon T04-134 ROUGE",
    },
  ];
  private headers2 = [
    {value: "name", text: "Nom"},
    {value: "level", text: "Niveau"},
    {value: "actions", text: ""},
  ];
  private items2 = [
    {
      name: "PASSE GENERAL",
      level: 1,
    },
    {
      name: "PASSE GENERAL TECHNIQUE",
      level: 2,
    },
    {
      name: "PASSE CLIM PLOMBERIE",
      level: 2,
    },
    {
      name: "CLE CANON T04-134",
      level: 3,
    },
  ];
}
